import { j as t } from "../../../../_virtual/jsx-runtime.js";
import { forwardRef as j, useState as v, useEffect as b } from "react";
import y from "../../SkeletonWrapper/index.js";
import { cn as m } from "../../../../lib/utils.js";
import { heightStyles as C, baseStyles as T } from "../styles.js";
import w from "../../Toggle/index.js";
const N = j(
  ({
    isLoading: f,
    className: g,
    label: l,
    defaultChecked: u,
    checked: e,
    onChange: a,
    labelClassName: x,
    ...s
  }, h) => {
    const r = s.id || s.name, [o, n] = v(
      u || e || !1
    );
    b(() => {
      e !== void 0 && n(e);
    }, [e]);
    const c = (i) => {
      const d = i.target.checked;
      a && a(i), e === void 0 && n(d);
    }, p = () => {
      const i = !o;
      n(i), c({
        target: {
          checked: i
        }
      });
    };
    return /* @__PURE__ */ t.jsx(y, { full: !0, isLoading: f, children: /* @__PURE__ */ t.jsxs(
      "div",
      {
        className: m(
          "flex items-center justify-between gap-2",
          T,
          C,
          g
        ),
        children: [
          l && /* @__PURE__ */ t.jsx(
            "label",
            {
              htmlFor: r,
              className: m(
                "text-slate-700 text-base cursor-pointer",
                s.disabled && "opacity-50 cursor-not-allowed",
                x
              ),
              children: l
            }
          ),
          /* @__PURE__ */ t.jsxs("div", { className: "relative inline-flex items-center", children: [
            /* @__PURE__ */ t.jsx(
              "input",
              {
                type: "checkbox",
                ref: h,
                className: "sr-only",
                id: r,
                checked: e !== void 0 ? e : o,
                onChange: c,
                ...s
              }
            ),
            /* @__PURE__ */ t.jsx(
              w,
              {
                disabled: s.disabled,
                isActive: o,
                onToggle: p
              }
            )
          ] })
        ]
      }
    ) });
  }
);
N.displayName = "ToggleInput";
export {
  N as default
};
